import React, { useState } from 'react'
import { IoCopyOutline } from 'react-icons/io5'
import Tooltip from 'britive-design-system/core/components/tooltip'
import './index.scss'
const CopyButton = ({ textToCopy }) => {
  const [tooltipText, setTooltipText] = useState('Copy')

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setTooltipText('Copied!')
      setTimeout(() => setTooltipText('Copy'), 3000) // Reset after 3 sec
    } catch (error) {
      setTooltipText('Failed!')
    }
  }

  return (
    <>
      <Tooltip title={tooltipText} position="right">
        <div className="copy-icon" onClick={handleCopy}>
          <IoCopyOutline size={16} />
        </div>
      </Tooltip>
    </>
  )
}

export default CopyButton
